export default "__VITE_ASSET__CfjYTDeF__"